import EntityWithNameStore from "./EntityWithNameStore";
import ProjectStore from "./ProjectStore";
import _ from "underscore";

class CustomerStoreClass extends EntityWithNameStore
{
    _onRemove(customer)
    {
        super._onRemove(customer);
        ProjectStore.removeMany(_.pluck(ProjectStore.getByCustomer(customer.id), 'id'));
    }
}

const CustomerStore = new CustomerStoreClass();
export default CustomerStore;


// WEBPACK FOOTER //
// ./web/js/store/CustomerStore.js